import React from "react";
import { Link } from "react-router-dom";
import { useContent } from "../context/ContentContext";
import SafeImage from "../components/SafeImage";

export default function AgroTourism() {
  const { content } = useContent();
  const a = content.agroTourism || {};
  const activities = a.activities || [];
  const galleryImages = a.galleryImages || [];
  return (
    <div className="container py-4">
      <h1 className="mb-4 text-success">{a.title || "Agro-Tourism"}</h1>
      <div className="row g-4 mb-4">
        {activities.map((activity, i) => (
          <div key={i} className="col-md-4">
            <div className="card h-100 shadow-sm">
              <SafeImage src={activity.image} className="card-img-top" alt={activity.name} style={{ height: 160, objectFit: "cover" }} />
              <div className="card-body">
                <h5 className="card-title text-success">{activity.name}</h5>
                <p className="card-text">{activity.description}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="alert alert-success">
        <h5>{a.bookTitle || "Book a Visit or Enquire"}</h5>
        <p>{a.bookText || ""} <Link to="/enquiries" className="text-warning">Fill out our enquiry form</Link> and we'll respond within 24 hours.</p>
      </div>
      <div className="mb-4">
        <h5 className="text-success">Image Gallery</h5>
        <div className="row g-2">
          {galleryImages.map((img, i) => (
            <div key={i} className="col-6 col-md-3">
              <SafeImage src={img.src} alt={img.alt || ""} className="img-fluid rounded" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
